import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import HomeIcon from "../assets/Home.svg";
import DashboardIcon from "../assets/dashboards.svg";
import AssistantIcon from "../assets/assistant.svg";
import HelpIcon from "../assets/help-ico.svg";
import AdminIcon from "../assets/settings2.svg";
import LogoIcon from "../assets/LogoWrap.svg";
import { ListItemButton } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { UserInfo } from '../services/common';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';

const drawerWidth = 80;

interface VisibleElementInfo {
    text: string;
    uri?: string;
    icon: string;
    href?: string;
    tooltip?: string;
}

interface NavBar3Props {
    userInfo: UserInfo;
}

const NavBar3 = ({ userInfo }: NavBar3Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [visibleElements, setVisibleElements] = React.useState<VisibleElementInfo[]>([{ text: 'Home', uri: '/', icon: HomeIcon }]);
    const loadNavItems = async () => {
        if (userInfo?.hasAnyRole === true) {
            setVisibleElements([
                { text: 'Home', uri: '/', icon: HomeIcon },
                { text: 'Dashboards', uri: '/dashboards', icon: DashboardIcon },
                { text: 'Assistant', uri: '/assistant', icon: AssistantIcon },
                { text: 'Help', href: 'https://migration.idaas.pwc.com/', icon: HelpIcon, tooltip: 'IDaaS Migration Docusite'}
            ]);
        }
    };
    React.useEffect(() => {
        loadNavItems();
    }, [userInfo]);
    
    const drawer = (
        <div>
            <List sx={{ display: 'block', fontFamily: 'Arial', fontSize: '9px' }}>
                {
                    visibleElements.map((o) => (
                        <ListItem key={o.text} disablePadding>
                            <Tooltip title={o.tooltip} arrow>
                            <ListItemButton className={location.pathname === o.uri ? 'active' : ''} sx={{ display: 'block', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', border: 'black' }} onClick={() => {
                                if (o.href) {
                                    // External link - open in new tab
                                    window.open(o.href, '_blank', 'noopener,noreferrer');
                                } else {
                                    // Internal route - use navigate
                                    navigate(o.uri);
                                }
                            }}>
                            <img src={o.icon}></img><div>{ o.text }</div>
                                </ListItemButton>
                            </Tooltip>
                    </ListItem>
                    ))}
                {userInfo?.isAdmin ? 
                    <ListItem key="Admin" disablePadding>
                        <ListItemButton className={location.pathname === '/adminConsole' ? 'active' : ''} sx={{ display: 'block', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', border: 'black' }} onClick={() => navigate('/adminConsole')}>
                            <img src={AdminIcon}></img><div>Admin</div>
                        </ListItemButton>
                    </ListItem>
                    : ''}
                </List>
        </div>
    );

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position="fixed" color="inherit" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ display: 'flex', marginRight: '5px' }}>
                        <img src={LogoIcon}></img>
                    </Typography>
                        <Typography variant="h6" component="div" sx={{ display: 'flex', fontFamily: '"Helvetica Neue", Arial, sans-serif', fontWeight: 400, fontSize: '16px', marginBottom: '5px' }}>
                            <p>Migration Portal</p>
                        </Typography>
                </Toolbar>
            </AppBar>
            <Drawer color="transparent"
                        variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', borderRightStyle: 'none' },
                }}
            >
                <Toolbar />
                        {drawer}
                    </Drawer>

        </Box>
    );
}

export default NavBar3; 